import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { Lock } from '@mui/icons-material';
import { useStyles } from './styles';
import { useAuthUser } from 'features/auth/AuthUserContext';

const Props = {
  creation: PropTypes.shape({
    name: PropTypes.string.isRequired,
    deleted: PropTypes.number.isRequired,
    thumb: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }).isRequired,
  blockedAccess: PropTypes.bool,
};

export default function CardMedia({ creation, blockedAccess }) {
  const classes = useStyles();
  const { user } = useAuthUser();
  const isBlockedAccess = blockedAccess && user.id === creation.user && !creation.deleted;

  function getCreationType() {
    const creationTypes = {
      0: '⚠️  Outdated Creation',
      1328531: 'Graphical Abstracts',
      800600: 'Slides Presentations',
      595842: 'Infographics',
      711948: 'Posters',
    };

    const key = creation.new_version === 0 ? '0' : `${creation.width}${creation.height}`;

    return creationTypes[key] || 'Custom';
  }

  return (
    <div className={classes.cardMedia}>
      <div className={classes.cardMediaBadge}>
        <Typography variant="caption">{getCreationType()}</Typography>

        {isBlockedAccess && (
          <div>
            <Lock fontSize="small" />
          </div>
        )}
      </div>

      <img src={creation.thumb} alt={`Creation ${creation.name}`} />
    </div>
  );
}

CardMedia.propTypes = Props;
